import Model from "~/models/_Model";
import Student from "~/models/eschoolplus/registration/Student";
import dayjs from "dayjs";

export default class Statistic extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "statistics";
  }

  primaryKey() {
    return "STUDENT_ID";
  }

  relations() {
    return {
      student: Student,
    };
  }

  /**
   * Helper Methods
   */
  getTierDisplayColor(tierLevel) {
    switch (tierLevel) {
      case 3:
        return "negative";
      case 2:
        return "warning";
      case 1:
        return "positive";
      default:
        return "negative";
    }
  }

  getFailuresDisplayColor(failureCount) {
    switch (failureCount) {
      case 0:
      case "None":
        return "positive";

      case 1:
        return "warning";

      default:
        return "negative";
    }
  }

  getAttendanceRateDisplayColor(attendanceRate) {
    if (!attendanceRate || attendanceRate >= 93) {
      return "primary";
    } else if (attendanceRate >= 84) {
      return "warning";
    } else {
      return "negative";
    }
  }

  getIncidentsDisplayColor(incidentCount) {
    if (!incidentCount || incidentCount < 6) {
      return "primary";
    } else if (incidentCount < 10) {
      return "warning";
    } else {
      return "negative";
    }
  }

  /**
   * Helper Attributes
   */

  get display_advisor_teacher() {
    return this.access_teacher || "None";
  }

  get display_tapestry_advocate() {
    return this.tapestry_advocate || "None";
  }

  get display_attendance_rate() {
    if (!this.attendance_rate) {
      return "N/A";
    }
    return this.attendance_rate + "%";
  }

  get cognos_report_url() {
    return `https://cognos.leyden212.org/ibmcognos/bi/?pathRef=.public_folders%2FTAC%2BReports%2FDrawer%2B-%2BMTSS%2BStatus%2BSummary&format=PDF&prompt=false&dsn=Leyden_Live&p_SID=${this.STUDENT_ID}&ui_appbar=false&ui_navbar=false`;
  }

  get cognos_communication_log_url() {
    return `https://cognos.leyden212.org/ibmcognos/bi/?pathRef=.public_folders%2FInterventions%2FMTSS%2BCommunication%2BLogs%2B%2528By%2BID%2529&format=PDF&Download=false&prompt=true&dsn=Leyden_Live&p_student_id=${this.STUDENT_ID}&ui_appbar=false&ui_navbar=false`;
  }

  get latest_mp_type() {
    if (
      (!this.last_mp_date || this.last_mp_date == "None") &&
      (!this.last_ipr_date || this.last_ipr_date == "None")
    ) {
      return "None";
    } else if (!this.last_ipr_date || this.last_ipr_date == "None") {
      return "Report Card";
    } else if (!this.last_mp_date || this.last_mp_date == "None") {
      return "Progress Report";
    } else {
      return dayjs(this.last_mp_date).isAfter(
        dayjs(this.last_ipr_date, "MM/DD/YYYY")
      )
        ? "Report Card"
        : "Progress Report";
    }
  }

  get latest_mp_date() {
    switch (this.latest_mp_type) {
      case "Report Card":
        return dayjs(this.last_mp_date).format("MM/DD/YYYY");

      case "Progress Report":
        return dayjs(this.last_ipr_date, "MM/DD/YYYY").format("MM/DD/YYYY");

      default:
        return "None";
    }
  }

  get latest_mp_failures() {
    switch (this.latest_mp_type) {
      case "Report Card":
        return this.mp_failures;

      case "Progress Report":
        return this.ipr_failures;

      default:
        return 0;
    }
  }
}
